import React, { useState, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';

import './home.css';
import backgroundImageGrid from '../../assets/images/purple-grid_a50.png';
import showcaseAnimation from '../../assets/images/cube-animation.gif';
import Footer from '../footer/footer';
import { NavLink } from 'react-router-dom';
import { graphqlRequest } from '../../services/graphql-service';
import { GET_TRACKS_BY_IDS } from '../../config/queries.js';
import { setPlaylist } from '../../features/audioPlayer/audioPlayerSlice';

// import { useDispatch } from 'react-redux';
// import { setLoginVisible } from '../../features/dialogControl/dialogControlSlice';
import { featured_tracks_ids } from '../../config/constants.js';

// const featured_tracks_ids = [
// 	'605e33b0-d8c1-4527-bb00-a30e29ed3362',
// 	'c1195719-99f9-41af-896f-a2d241fd6c24',
// 	'2aec1d0c-3036-4eea-b582-fbafd29d4a36',
// 	'397fe8d3-1e37-4df3-bfdb-267d292e697b',
// 	'9977884b-52ae-494a-8f63-fd1166dad8f6',
// 	'f8232121-d558-4e46-be5b-b588d04284e5'
// ];

const Home = () => {
	const dispatch = useDispatch();
	const [featuredTracks, setFeaturedTracks] = useState(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);
	const carouselRef = useRef(null);
	useEffect(() => {
		const fetchTracksData = async () => {
			try {
				setLoading(true);
				const data = await graphqlRequest(GET_TRACKS_BY_IDS, { trackIds: featured_tracks_ids }); 
				selectFeaturedTracks(data.tracksByIds);
			} catch (err) {
				setError(err.message);
			} finally {
				setLoading(false);
			}
		};

		const selectFeaturedTracks = (tracks) => {
            // TODO: this should be driven by some sort of db table
            const featuresLength = 10;
            const shuffledArray = [...tracks];
            for (let i = shuffledArray.length - 1; i > 0; i--) {
              const j = Math.floor(Math.random() * (i + 1));
              [shuffledArray[i], shuffledArray[j]] = [shuffledArray[j], shuffledArray[i]]; // Swap elements
            }
            const data = shuffledArray.slice(0,featuresLength)
            setFeaturedTracks(data);
        }
		
        fetchTracksData();
    }, []);

	const scrollCarousel = (direction) => {
		if (carouselRef.current) {
			const container = carouselRef.current;
			const itemWidth = container.firstChild?.offsetWidth || 300; // Default item width
			const visibleItems = Math.floor(container.offsetWidth / itemWidth);
			const scrollAmount = visibleItems * itemWidth;
			container.scrollBy({ left: direction * scrollAmount, behavior: 'smooth' });
		}
	};

	return (
		<div>
			<div className='video-container'>
				<video autoPlay loop muted playsInline>
					<source src="video/hero-loop.mp4" type="video/mp4" />
					Your browser does not support the video tag.
				</video>
				<div className="video-overlay-content">
					Content Solutions for AI Creators and Platforms
				</div>
				
			</div>

			{/* artists */}
			<div className='content-block'
				style={{ backgroundImage: `url(${backgroundImageGrid})`}}
			>

				<div className='headline-block'>
					<div className='headline'>Explore artist-powered tracks, stems & metadata</div>
					<NavLink to='/artists' className='nav-link'>
						<div 
							// TODO: standardize this type of right side small copy
							style={{ 
								minWidth: '90px',
								textAlign: 'right'
							}}
						>SEE ALL</div>
					</NavLink>
				</div>

				<div className="carousel-container">
					<button className="carousel-button left" onClick={() => scrollCarousel(-1)}>‹</button>
				
					<div className='artist-carosel' ref={carouselRef}>
						{!loading && 
							featuredTracks.map((f) => {
								return (
									<NavLink 
										className='home-nav-link'
										to={`/track/${f.id}`} 
										key={f.id}
									>
										<div className='carosel-item-container'
											
											style={{ backgroundImage: `url(https://media.tracktribe.com/images/track_images/${f.image})`}}
											onClick={() => dispatch(setPlaylist(featuredTracks))}
										>
											<div className='carosel-title'>{f.title}</div>
										</div>
									</NavLink>
								)
							})
						}
						{loading &&
							<div>loading...</div>
						}

						{error &&
							<div>{error.message}</div>
						}
					</div>
					<button className="carousel-button right" onClick={() => scrollCarousel(1)}>›</button>					
				</div>
			</div>
			
			{/* explainer */}
			<div className='content-block content-block-row'
				
			>
				<div className='content-left'>
					<div className='headline'>Music Modernized: Music's AI Revolution</div>
					<div className='content-copy'>
						<p>The music industry is undergoing a seismic shift due to rapid AI advancements. Legacy systems are ill-equipped to handle the challenges ahead, hindered by complex restrictions and outdated frameworks.

						In this evolving landscape, making music accessible while ensuring robust content protection is crucial. Current mechanics can't support AI-driven music creation and distribution, leaving artists and stakeholders at a crossroads.

						MusicBlox bridges these gaps, benefiting creators and platforms alike. We're tackling this in three ways:</p>

						<ul>
							<li>Aggregating and licensing AI training content to platforms.</li>
							<li>Investing in cutting-edge content protection technologies.</li>
							<li>Developing a creator-controlled content licensing platform.</li>
						</ul>

						
					</div>
				</div>
				<div className='content-right'>
					<div className='showcase-image-container'>
						<img  src={showcaseAnimation} alt='' />
					</div>
					<div className='content-right-subscript'>
						Unlocking Music's Full Potential: Every track and stem holds vast untapped value. Integrating them into new products automates transactions, expands artist revenue streams, and future-proofs content management for AI.
					</div>
				</div>
			</div>

			

			<Footer />
		</div>
  );
};

export default Home;